import _ from 'lodash';
import React, { Component } from 'react';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
import { dp, loopIndex, videoType } from '../../../utils/shared';
import { DONOR, FOLDER, FOLDER_DONOR_LIST, FOLDER_ONE_COLUMN_DONOR_LIST, FOLDER_THREE_COLUMN_DONOR_LIST, FOLDER_THREE_COLUMN_DONOR_LIST_CAPITAL, FOLDER_THREE_COLUMN_DONOR_LIST_CUMULATIVE, FOLDER_TWO_COLUMN_DONOR_LIST, OPACITY_COLOR, OPACITY_PERCENTAGE, STORY, STORY_DOUBLE_IMAGE, STORY_FULLSCREEN, STORY_SINGLE_IMAGE, STORY_TEXT_ONLY } from './AlbuquerqueConstants';
import AlbuquerqueDonor from './AlbuquerqueDonor';
import AlbuquerqueDonorList from './AlbuquerqueDonorList';
import AlbuquerqueStoryDoubleImage from './AlbuquerqueStoryDoubleImage';
import AlbuquerqueStoryFullScreen from './AlbuquerqueStoryFullscreen';
import AlbuquerqueStorySingleImage from './AlbuquerqueStorySingleImage';
import AlbuquerqueStoryTextOnly from './AlbuquerqueStoryTextOnly';

class AlbuquerqueAttractLoop extends Component {
  constructor(props) {
    super(props);
    this.state = { currentIndex: 0, donorListCycleIndex: 0 };
  }

  componentDidMount() {
    window.addEventListener('keydown', this.handleCicleKeyDown);
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.handleCicleKeyDown);
  }

  handleCicleKeyDown = (e) => {
    let cycleKey = _.get(this.props.tree, 'contents.custom_fields.cycle_key.val', null);
    if (e.key === cycleKey) {
      this.cycle();
    }
  }

  cycle = (forceNextModule) => {
    const module = this.props.tree.children[this.state.currentIndex];
    const type = _.get(module, 'contents.custom_fields.folder_type.val.value', null);
    const donorListsTypes = [FOLDER_TWO_COLUMN_DONOR_LIST, FOLDER_THREE_COLUMN_DONOR_LIST, FOLDER_THREE_COLUMN_DONOR_LIST_CAPITAL, FOLDER_THREE_COLUMN_DONOR_LIST_CUMULATIVE, FOLDER_DONOR_LIST];

    if (donorListsTypes.indexOf(type) > -1 && !forceNextModule) {
      this.setState({ donorListCycleIndex: this.state.donorListCycleIndex + 1 });
    } else {
      const max = this.props.tree.children.length - 1;
      const nextIndex = loopIndex(this.state.currentIndex, 0, max, "forward");
      this.setState({ currentIndex: nextIndex, donorListCycleIndex: 0 });
    }

  }

  getCurrentRenderedModule = () => {
    const module = this.props.tree.children[this.state.currentIndex];
    let renderedModule = null;
    switch (module.node_type) {
      case STORY:
        renderedModule = this.getRenderedStory(module);
        break;
      case FOLDER:
        renderedModule = this.getRenderedFolder(module);
        break;
      default:
        break;
    }
    return renderedModule;
  }

  getRenderedStory = module => {
    const type = _.get(module, 'contents.custom_fields.story_type.val.value', null);
    switch (type) {
      case STORY_SINGLE_IMAGE:
        return <AlbuquerqueStorySingleImage
          module={module}
          cycle={this.cycle}
          width={this.props.width}
          height={this.props.height}
          screen={this.props.screen}
        />
      case STORY_DOUBLE_IMAGE:
        return <AlbuquerqueStoryDoubleImage 
          module={module}
          cycle={this.cycle}
          width={this.props.width}
          height={this.props.height}
          screen={this.props.screen}
        />
      case STORY_TEXT_ONLY:
        return <AlbuquerqueStoryTextOnly
          module={module}
          cycle={this.cycle}
          width={this.props.width}
          height={this.props.height}
          screen={this.props.screen}
        />
      case STORY_FULLSCREEN:
        return <AlbuquerqueStoryFullScreen
          module={module}
          cycle={this.cycle}
          width={this.props.width}
          height={this.props.height}
          screen={this.props.screen}
        />
      case DONOR:
        return <AlbuquerqueDonor
          module={module}
          cycle={this.cycle}
          width={this.props.width}
          height={this.props.height}
          screen={this.props.screen}
        />
      default:
        return null;
    }
  }

  getRenderedFolder = module => {
    const type = _.get(module, 'contents.custom_fields.folder_type.val.value', null);
    switch (type) {
      case FOLDER_ONE_COLUMN_DONOR_LIST:
        return <AlbuquerqueDonor
          module={module}
          content={this.props.content}
          cycle={this.cycle}
          donors={this.props.donors}
          width={this.props.width}
          height={this.props.height}
          screen={this.props.screen}
        />
      case FOLDER_TWO_COLUMN_DONOR_LIST:
      case FOLDER_THREE_COLUMN_DONOR_LIST:
      case FOLDER_THREE_COLUMN_DONOR_LIST_CAPITAL:
      case FOLDER_THREE_COLUMN_DONOR_LIST_CUMULATIVE:
      case FOLDER_DONOR_LIST:
        return <AlbuquerqueDonorList
          key={module.id}
          module={module}
          content={this.props.content}
          donors={this.props.donors}
          cycle={this.cycle}
          cycleIndex={this.state.donorListCycleIndex}
          width={this.props.width}
          height={this.props.height}
        />
      default:
        return null;
    }
  }

  getBackground = (i = 0) => {
    const module = this.props.tree;
    let imgObj = _.get(module, `contents.images[${i}]`, null);
    if (imgObj) {
      return dp(this.props.screen, imgObj, null);
    }
    return null;
  }

  render() {
    const videoStyle = {
      preload: 'auto',
      width: this.props.width,
      minHeight: '100%',
      zIndex: 0,
      loop: '',
      autoplay: "",
      muted: "",
      pointerEvents: "none"
    }
    const renderedModule = this.getCurrentRenderedModule();
    const { width, height } = this.props;
    const style = { position: "absolute", width, height, top: 0 };    
    let index = this.state.currentIndex;    

    const background = this.getBackground();
    const type = videoType(background);

    return (
      <div>
        <div style={{ position: "absolute", width: "100%", height: "100%", opacity: OPACITY_PERCENTAGE, backgroundColor: OPACITY_COLOR }}/>
        <div style={{ width, height, pointerEvents: "none", left: 0, top: 0 }}>
          <video className="nodrag" style={videoStyle} id="background-video" loop autoPlay muted>
            <source src={background} type={type} />
            Your browser does not support the video tag.
          </video>
        </div>
        <CSSTransitionGroup
          transitionName='fastfadedelay'
          transitionEnterTimeout={0}
          transitionLeaveTimeout={0}>
          <div key={index} style={style}>
            {renderedModule}
          </div>
        </CSSTransitionGroup>
      </div>
    )
  }
}
export default AlbuquerqueAttractLoop;


// WEBPACK FOOTER //
// ./src/Components/Theme/Albuquerque/AlbuquerqueAttractLoop.jsx